import { render, staticRenderFns } from "./CreateAdminUserRelationship.vue?vue&type=template&id=dc741b36&scoped=true&"
import script from "./CreateAdminUserRelationship.vue?vue&type=script&lang=js&"
export * from "./CreateAdminUserRelationship.vue?vue&type=script&lang=js&"
import style0 from "./CreateAdminUserRelationship.vue?vue&type=style&index=0&id=dc741b36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc741b36",
  null
  
)

export default component.exports